import { useState } from 'react';
import { getCurrentApiUrl, setApiUrl } from '../api/client';

const SERVER_OPTIONS = [
  { label: 'Default (3000)', url: 'http://localhost:3000' },
  { label: 'Server 1 (3001)', url: 'http://localhost:3001' },
  { label: 'Server 2 (3002)', url: 'http://localhost:3002' },
];

export function DevServerSwitcher() {
  const [currentUrl, setCurrentUrl] = useState(getCurrentApiUrl());
  const [isOpen, setIsOpen] = useState(false);

  // Only show in development
  if (!import.meta.env.DEV) return null;

  const handleSelect = (url: string) => {
    setApiUrl(url);
    setCurrentUrl(url);
    setIsOpen(false);
    // Reload to reconnect sockets etc.
    window.location.reload();
  };

  const currentLabel = SERVER_OPTIONS.find(o => o.url === currentUrl)?.label || currentUrl;

  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      left: '10px',
      zIndex: 9999,
      fontFamily: 'monospace',
      fontSize: '12px',
    }}>
      {isOpen ? (
        <div style={{
          background: '#1a1a1a',
          border: '1px solid #444',
          borderRadius: '4px',
          padding: '8px',
        }}>
          <div style={{ marginBottom: '8px', color: '#888' }}>API Server:</div>
          {SERVER_OPTIONS.map(opt => (
            <button
              key={opt.url}
              onClick={() => handleSelect(opt.url)}
              style={{
                display: 'block',
                width: '100%',
                padding: '6px 10px',
                marginBottom: '4px',
                background: opt.url === currentUrl ? '#3b82f6' : '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '3px',
                cursor: 'pointer',
                textAlign: 'left',
              }}
            >
              {opt.label}
            </button>
          ))}
          <button
            onClick={() => setIsOpen(false)}
            style={{
              marginTop: '4px',
              padding: '4px 8px',
              background: 'transparent',
              color: '#888',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(true)}
          style={{
            padding: '6px 10px',
            background: '#1a1a1a',
            color: '#888',
            border: '1px solid #444',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          API: {currentLabel}
        </button>
      )}
    </div>
  );
}
